<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/bg3.jpg" alt="">

      <div class="page3-info">

        <div class="p">
          感谢您一直以来对绿色生态保护、文化遗产传承以及国宝李渡品牌发展的高度关注与大力支持！
        </div>
        <div class="p">
          国宝李渡始终秉承“天人合一”的酿造哲学，致力于将传统工艺与现代环保理念深度融合。为助力中国白酒申遗，践行ESG可持续发展理念，特举办“植此青绿
          助力申遗”国宝李渡植树公益行活动，诚邀您共同参与，以行动守护生态，以绿色赋能中国白酒申遗。
        </div>
      </div>

      <div class="btn-submit fcc">
        <img src="@/assets/btn-get.png" alt="" @click="showPopSign = true">
      </div>


      <van-overlay :show="showLoading">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>

      <van-overlay :show="showPopSign" z-index="999" @click="showPopSign = !showPopSign" @touchstart="handleTouchStart">
        <div class="fcc-h gz-pop" style="height: 100vh; overflow: auto;">
          <div class="f-pr gz-pop-con fcc-h" @click.stop=''>
            <div class="fcc">
              <!-- <img src="../assets/yqjzb.png" alt="" class="img1"> -->
            </div>



            <!-- 盖章区域 -->
            <div class="gz-area fcc ">
              <img src="../assets/gzq.png" alt="">
            </div>


            <div class="gz-tips fcc">
              <img src="../assets/zcgz.png" alt="">
            </div>
            <div class="fix-btn" @click="showPopSign = !showPopSign">

              <van-icon name="cross" size="36" color="#fff" />
            </div>
          </div>
        </div>
      </van-overlay>
      <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
        <audio id="audioID" ref="audio" class="aud">
          <source src="https://park.warnny.com/duang.mp3" type="audio/mp3" />
        </audio>
      </div>


    </div>
  </div>
</template>

<script>

import { checkTask } from "@/api/api";
import { check } from "@/utils/check"
import CryptoJS from 'crypto-js'

export default {


  data() {
    return {
      showLoading: false,
      showPopSign: false,
      userInfo: {}
    }
  },

  async mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.$nextTick(() => {
      let Media = document.getElementById("audioID");
      Media.src = "https://tree.warnny.com/duang.mp3";
    })
  },

  methods: {
    openPopup() {
      this.showPopSign = true
    },
    async handleTouchStart(event) {
      let that = this;
      if (event.touches.length != 4) {
        return
      }
      if (this.gaizhangCount > 5) {
        that.$toast("盖章失败次数达5次，请输入口令")
        return
      }
      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        //时间戳
        let request = {
          taskName: that.userInfo.username,
          timestamp: timestamp,
          userId: that.userInfo.username
        }
        console.log("request:", request)
        let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
        console.log("request:", md5Result)
        request.sign = md5Result
        request.method = 1
        checkTask(request).then(res => {
          if (res && res.msg) {
            this.$toast(res.msg)
            this.checking = false
          } else if (res) {
            that.showPopSign = false
            that.$toast("打卡成功")
            document.querySelector('audio').play()
            document.getElementById("audioID").play()
            that.checking = false
            setTimeout(function(){
              that.$router.push({ path: '/index3' })
            }, 2000)
          } else {
            that.$toast("打卡失败，请重试")
            that.checking = false
          }
        })
      }
    },
  }



}

</script>
<style scoped lang="less">
.page {
  display: block;

  min-height: 100vh;
  background: #D6F9D8;
  background-size: 100% auto;
  // background-size: cover;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}


.btn-submit {
  width: 184px;
  height: 184px;
  position: absolute;
  top: 1013px;
  left: 50%;
  transform: translateX(-50%);

  img {
    display: block;
    width: 100%;
  }
}


.page3-info {
  position: absolute;
  left: 94px;
  right: 94px;
  top: 345px;

  font-weight: 300;
  font-size: 26px;
  color: #000000;
  line-height: 55px;

  .p {
    text-indent: 2em;

    font-weight: 300;
    font-size: 26px;
    color: #000000;
    line-height: 55px;
  }
}

.gz {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 50px;
  position: absolute;
  left: 93px;
  top: 880px;
  height: 245px;
  padding-top: 52px;
  background: url(../assets/z.png) 11px 0 no-repeat;
  background-size: 245px 245px;


}
</style>